import React, { useState, useEffect } from "react";
import { useMutation, useQueryClient } from "react-query";
import api from "../lib/api";
import { X } from "lucide-react";
import CloseIcon from "@/components/icons/CloseIcon";

const NeedHelpModel = ({ isOpen, onClose, }) => {
    return (
        <div
            className={`fixed inset-0 z-50 backdrop-blur-sm transition-opacity duration-300 ${isOpen ? "opacity-100" : "pointer-events-none opacity-0"}`}
        >
            <div
                className={`fixed inset-0 bg-white bg-opacity-50 transition-opacity duration-300 ${isOpen ? "opacity-100" : "opacity-0"}`}
                onClick={onClose}
            ></div>
            <div className="fixed inset-0 flex items-center justify-center p-4 overflow-y-auto">
                <div
                    className={`w-full max-w-xl transform rounded-lg bg-navy-500 p-6 transition-all duration-300 ${isOpen ? "scale-100 opacity-100" : "scale-95 opacity-0"
                        } max-h-screen overflow-y-auto sm:w-11/12 md:w-9/12 lg:w-8/12`}
                >
                    <div className="flex items-center justify-between mb-4">
                        <h2 className="relative text-lg font-semibold text-red-500 uppercase">Need Help?</h2>
                        <button
                            onClick={onClose}
                            className="absolute text-red-500 top-2 right-2 hover:text-red-400 focus:outline-none"
                        >
                            <CloseIcon className="w-8 h-8 text-red-500 transition-transform duration-200 cursor-pointer hover:scale-110" />
                        </button>
                    </div>
                    <p className="text-white">Administrator and queries to <a href="mailto:admin@minesure.com" className="text-red-500 hover:text-red-400">admin@minesure.com</a></p>
                </div>
            </div>
        </div>
    );
};
export default NeedHelpModel;